/**
 * @module builder
 */
import type { OptionsDocument, QuoteDocument } from 'paintscout'

import type { UpdateableGroup } from '../index'

import { getGroupSubstrateChildren, updateGroup } from '../../index'

import { getItem } from '../../items/get-items'
import { getFileKeysForItem } from '../../files'
import uniq from 'lodash/uniq'

export function addItemsToGroup(args: {
  quote: QuoteDocument
  options: OptionsDocument
  group: UpdateableGroup
  keys: string[]
}): QuoteDocument {
  const { quote, options, group, keys } = args

  const items = keys.map((key) => getItem({ quote, options, key }))

  // get file keys from item and add to group
  const files = [
    ...group.files,
    ...items.reduce((allFiles, item) => {
      return [...allFiles, ...getFileKeysForItem({ item })]
    }, [])
  ]

  const updatedGroup: UpdateableGroup = {
    ...group,
    children: [...keys, ...group.children],
    substrateChildren: uniq([
      ...(group?.substrateChildren ?? []),
      ...getGroupSubstrateChildren({ quote, options, section: group.section, keys })
    ]),
    files
  }

  const updatedQuote = updateGroup({
    quote,
    options,
    group: updatedGroup,
    calculate: true
  })

  return updatedQuote
}
